'use client';

import { type JSX, type ReactNode } from 'react';

import { Text } from '@videoblocks/design-system';
import { Search } from '@videoblocks/react-icons';

interface AllResultsSectionProps {
    count: number;
    children: ReactNode;
}

export function AllResultsSection({ count, children }: AllResultsSectionProps): JSX.Element {
    return (
        <section className="flex flex-col gap-2 px-6 py-2">
            <div className="flex items-center gap-2">
                <Search className="size-4 shrink-0 text-gray-800" />
                <Text asChild fontSize="base" fontWeight="semibold" className="text-gray-800">
                    <h2>All results</h2>
                </Text>
                <Text fontSize="xs" fontWeight="regular" className="text-gray-600">
                    {count} {count === 1 ? 'result' : 'results'}
                </Text>
            </div>
            {children}
        </section>
    );
}
